import {Component, computed, input, OnDestroy, resource, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {User} from '../../../api/models/user';
import {Exam} from '../../../api/models/exam';

import {SurveyService} from '../../../api/services/survey.service';
import {AuthService} from '../../../api/services/auth.service';
import {Subscription} from 'rxjs';
import {ExamListComponent} from '../../assignments-list/exam-list/exam-list.component';
import {
  WaCalloutDirective,
  WaIconDirective,
  WaTabComponent,
  WaTabGroupComponent,
  WaTabPanelComponent,
  WaToastService
} from "angular-awesome";
import {StaffMemberListComponent} from "../../assignments-list/staffmember-list/staffmember-list.component";

@Component({
    selector: 'app-survey-detail',
    templateUrl: './survey-detail.component.html',
    styleUrls: ['./survey-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ExamListComponent, WaCalloutDirective, WaIconDirective, WaTabComponent, WaTabGroupComponent, WaTabPanelComponent, StaffMemberListComponent]
})
export class SurveyDetailComponent implements OnDestroy {

  private userSub: Subscription;

  surveyId = input.required<number>();
  params = computed(() => ({
    id: this.surveyId(),
  }));
  survey = resource({
    params: this.params,
    loader: ({ params }) => {
      console.log("Fetching survey with id "+params.id)
      return this.surveyService.get(params.id);
    },
  });


  selectedExam: Exam | null = null;
  user: User | null = null;

  constructor(private authService: AuthService,
              private surveyService: SurveyService,
              private toastService: WaToastService,
              private route: ActivatedRoute) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => this.user = user,
      error: err => {
        this.toastService.danger('Could not fetch current user.');
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }
}
